var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcWarningBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 26,
    fill: "#FFA500"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8 40C27.3464 40 28.6 38.8393 28.6 37.4074C28.6 35.9756 27.3464 34.8148 25.8 34.8148C24.2536 34.8148 23 35.9756 23 37.4074C23 38.8393 24.2536 40 25.8 40ZM25.8 12C24.2536 12 23 13.1607 23 14.5926V30.1481C23 31.58 24.2536 32.7407 25.8 32.7407C27.3464 32.7407 28.6 31.58 28.6 30.1481V14.5926C28.6 13.1607 27.3464 12 25.8 12Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWarningBig);
export default __webpack_public_path__ + "static/media/ic_warning_big.e477ac638496396aa931426c43da229f.svg";
export { ForwardRef as ReactComponent };